// src/context/AlertContext.js
import React, { createContext, useContext } from "react";
import Swal from "sweetalert2";
import PropTypes from "prop-types";

// Create context
const AlertContext = createContext();

// Create provider
export const AlertProvider = ({ children }) => {
  const showAlert = async (message, options = {}) => {
    const swalResult = await Swal.fire({
      title: options.title || "Error",
      text: message,
      icon: options.icon || "error", // "success", "error", "warning", etc.
      confirmButtonText: options.confirmButtonText || "Okay",
      timer: options.timer || 5000,
      showConfirmButton: options.showConfirmButton ?? false,
      customClass: {
        popup: "sweetalert-bootstrap-modal",
        container: "sweetalert-bootstrap-container",
      },
      didOpen: (popup) => {
        const container = popup?.parentElement;

        if (container) {
          container.style.zIndex = "20000";
        }

        if (typeof options.didOpen === "function") {
          options.didOpen(popup);
        }
      },
      ...options, // allows further customization
    });

    if (swalResult.dismiss === Swal.DismissReason.timer) {
      // Optionally perform something after auto-dismiss
    }
  };

  return <AlertContext.Provider value={{ showAlert }}>{children}</AlertContext.Provider>;
};

AlertProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Custom hook to use alert
export const useAlert = () => useContext(AlertContext);
